import React from "react";
import {NavLink} from "react-router-dom";
import Discovery from "../../views/Discovery";

const NavMenu = () => {

    const menuList = [
        // {
        //     icon: "discovery",
        //     label: "Discovery",
        //     path: "/metahuts/discovery"
        // },
        {
            icon: "metahut",
            label: "My Metahut",
            path: "/metahuts/mycollection"
        }
    ]

    return (
        <div className="flex items-center gap-x-2 nav-menu bg-transparent border-0 text-white uppercase">
            {menuList.map( (menuItem, index) => {
                return (
                    <NavLink to={menuItem.path} key={index} className="flex items-center gap-x-2 text-sm uppercase px-5 py-2 rounded-3xl">
                        <i className={`icon-${menuItem.icon} text-lg`}></i>
                        <span>{menuItem.label}</span>
                    </NavLink>
                )
            })}
        </div>
    )
}

export default NavMenu;